function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

import { hasOwnProperty } from "./core";
import { TEXT_ALIGNS, FLEX_DIRECTIONS, FLEX_PLACE_ITEMS } from "./constants";
export function getGapValues(gap, theme) {
  if (typeof gap === "number") {
    gap = String(gap);
  }

  if (typeof gap !== "string") {
    return null;
  }

  var parts = gap.split(/\s+/).filter(Boolean);

  if (parts.length < 1 || parts.length > 2) {
    return null;
  }

  var rowGapPx = theme.space[parts[0]] || "0px";
  var columnGapPx = parts.length === 2 ? theme.space[parts[1]] || "0px" : rowGapPx;
  return {
    rowGap: rowGapPx,
    columnGap: columnGapPx
  };
}

function getTextAlignValue(textAlign) {
  if (TEXT_ALIGNS.includes(textAlign)) {
    return textAlign;
  }

  return null;
}

var OVERFLOW_VALUES = ["visible", "hidden", "scroll", "auto"];

function getOverflowValue(overflow) {
  var parts = typeof overflow === "string" ? overflow.trim().split(/\s+/) : null;
  var isValid = parts !== null && parts.every(function (part) {
    return OVERFLOW_VALUES.includes(part);
  });

  if (isValid) {
    return parts.join(" ");
  }

  return null;
}

var SPAN_REGEX = /^(\d+)(-(\d+))?$/;
export function getGridLines(span) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$allAllowed = _ref.allAllowed,
      allAllowed = _ref$allAllowed === void 0 ? false : _ref$allAllowed;

  if (allAllowed && span === "all") {
    return [1, -1];
  }

  if (typeof span === "number") {
    return [span + 1, span + 2];
  }

  if (typeof span !== "string") {
    return null;
  }

  var match = span.match(SPAN_REGEX);

  if (match === null) {
    return null;
  }

  var start = parseInt(match[1], 10);
  var end = match[3] === undefined ? start : parseInt(match[3], 10);
  return [start + 1, end + 2];
}
export function getGapPx(gap, theme) {
  // Exception to our space scale
  if (gap === "30px") {
    return gap;
  }

  return theme.space[gap] || "0px";
}
export function getGridTemplateColumns(cols) {
  var colsInt = Number(cols);

  if (colsInt) {
    return "repeat(".concat(colsInt, ", 1fr)");
  }

  if (typeof cols === "string") {
    return cols;
  }

  return null;
}
export var getGridTemplateRows = getGridTemplateColumns;
export var DEFAULT_BREAKPOINT = "default";
export function compareBreakpoints(bp1, bp2, theme) {
  var breakpoints = [DEFAULT_BREAKPOINT].concat(_toConsumableArray(Object.keys(theme.breakpoints)));
  var index1 = breakpoints.indexOf(bp1);
  var index2 = breakpoints.indexOf(bp2);

  if (index1 === -1 || index2 === -1) {
    return null;
  }

  if (index1 === index2) {
    return 0;
  }

  return index1 < index2 ? -1 : 1;
}
export function getMinMediaQueries(breakpoints) {
  if (!breakpoints) {
    return {};
  }

  var result = {};

  for (var bp in breakpoints) {
    result[bp] = "@media (min-width: ".concat(breakpoints[bp], ")");
  }

  return result;
}
export function getExclusiveMediaQueries(breakpoints) {
  if (!breakpoints) {
    return {};
  }

  var entries = Object.entries(breakpoints).map(function (_ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
        bp = _ref3[0],
        px = _ref3[1];

    return {
      bp: bp,
      px: parseInt(px, 10)
    };
  });

  if (!entries[0]) {
    return {};
  }

  var result = _defineProperty({}, DEFAULT_BREAKPOINT, "(max-width: ".concat(entries[0].px - 1, "px)"));

  var i, len;

  for (i = 0, len = entries.length - 1; i < len; i++) {
    result[entries[i].bp] = "(min-width: ".concat(entries[i].px, "px) and (max-width: ").concat(entries[i + 1].px - 1, "px)");
  }

  result[entries[i].bp] = "(min-width: ".concat(entries[i].px, "px)");
  return result;
}

function sortMediaQueries(css) {
  var result = {};
  var minWidths = [];

  for (var key in css) {
    var match = key.match(/^@media \(min-width: (\d+)px\)$/);

    if (match) {
      var minWidth = parseInt(match[1], 10);
      minWidths.push(minWidth);
    } else {
      result[key] = css[key];
    }
  }

  minWidths.sort(function (a, b) {
    return a - b;
  }).forEach(function (minWidth) {
    var mediaQuery = "@media (min-width: ".concat(minWidth, "px)");
    result[mediaQuery] = css[mediaQuery];
  });
  return result;
}

export function mergeResponsiveCSS(css1, css2) {
  var result = {};

  for (var key in css1) {
    if (_typeof(css1[key]) === "object") {
      result[key] = _objectSpread({}, css1[key]);
    } else {
      result[key] = css1[key];
    }
  }

  for (var _key in css2) {
    if (_typeof(css2[_key]) === "object") {
      if (hasOwnProperty(result, _key)) {
        // merge with css1
        result[_key] = _objectSpread(_objectSpread({}, result[_key]), css2[_key]);
      } else {
        result[_key] = css2[_key];
      }
    } else {
      result[_key] = css2[_key]; // override css1
    }
  }

  return sortMediaQueries(result);
}
var MIN_MEDIA_QUERY_REGEX = /^@media \(min-width: (\d+)px\)$/;

function isMinMediaQuery(str) {
  return str.match(MIN_MEDIA_QUERY_REGEX) !== null;
}

export function isCSSinOrder(css) {
  var keys = Object.keys(css);
  var firstMinMediaQueryIndex = keys.findIndex(isMinMediaQuery);

  if (firstMinMediaQueryIndex === -1) {
    // No min media queries found. Nothing to worry about.
    return true;
  }

  var lastBreakpoint = -1;

  for (var i = firstMinMediaQueryIndex + 1; i < keys.length; i++) {
    var match = keys[i].match(MIN_MEDIA_QUERY_REGEX);

    if (match === null) {
      // Default CSS found. It must appear BEFORE ALL media queries.
      return false;
    }

    var breakpoint = parseInt(match[1], 10);

    if (breakpoint < lastBreakpoint) {
      // Min media queries must appear in acsending order.
      return false;
    }

    lastBreakpoint = breakpoint;
  }

  return true;
}
export function responsiveMargin(propsAtBreakpoint, theme) {
  var margin = theme.getSpaceValue(propsAtBreakpoint.margin);
  return margin === null ? {} : {
    margin: margin
  };
}
export function responsivePadding(propsAtBreakpoint, theme) {
  var padding = theme.getSpaceValue(propsAtBreakpoint.padding);
  return padding === null ? {} : {
    padding: padding
  };
}
var NUMBERS_ONLY_REGEX = /^\d+$/;

function addPxIfNeeded(str) {
  if (NUMBERS_ONLY_REGEX.test(str)) {
    return "".concat(str, "px");
  }

  return str;
}

export var responsiveSize = function responsiveSize(prop) {
  return function (propsAtBreakpoint) {
    var value = typeof propsAtBreakpoint[prop] === "string" && propsAtBreakpoint[prop].trim() !== "" ? addPxIfNeeded(propsAtBreakpoint[prop]) : null;
    return value === null ? {} : _defineProperty({}, prop, value);
  };
};
export function responsiveHasBreakpointWidth(_ref5, theme, bp) {
  var hasBreakpointWidth = _ref5.hasBreakpointWidth,
      margin = _ref5.margin;

  if (hasBreakpointWidth !== true) {
    if (margin) {
      return {
        maxWidth: "initial"
      };
    }

    return {
      maxWidth: "initial",
      marginLeft: "initial",
      marginRight: "initial"
    };
  }

  if (bp === DEFAULT_BREAKPOINT || !theme.breakpointMaxWidths[bp]) {
    return {
      marginLeft: "15px",
      // This is half of our special 30px columns gap.
      marginRight: "15px"
    };
  }

  return {
    maxWidth: theme.breakpointMaxWidths[bp],
    marginLeft: "auto",
    marginRight: "auto"
  };
}
export function responsiveTextStyle(propsAtBreakpoint, theme) {
  var css = theme.getTextStyleCSS(propsAtBreakpoint.textStyle);
  return css === null ? {} : css;
}
export function responsiveTextAlign(propsAtBreakpoint) {
  var textAlign = getTextAlignValue(propsAtBreakpoint.textAlign);
  return textAlign === null ? {} : {
    textAlign: textAlign
  };
}
export function responsiveOverflow(propsAtBreakpoint) {
  var overflow = getOverflowValue(propsAtBreakpoint.overflow);
  return overflow === null ? {} : {
    overflow: overflow
  };
}
export function responsiveFlexDirection(_ref6) {
  var direction = _ref6.direction;

  if (!FLEX_DIRECTIONS.includes(direction)) {
    return {};
  }

  return {
    flexDirection: direction
  };
}
export function responsiveFlexPlaceItems(_ref7) {
  var direction = _ref7.direction,
      placeItems = _ref7.placeItems;

  if (!FLEX_PLACE_ITEMS.includes(placeItems)) {
    return {};
  }

  var parts = placeItems.trim().split(/\s+/);

  if (parts.length === 1) {
    if (parts[0] === "center") {
      return {
        alignItems: "center",
        justifyContent: "center"
      };
    }

    return {};
  }

  if (parts.length !== 2) {
    return {};
  }

  if (parts[0] === "center" && parts[1] === "center") {
    return {
      alignItems: "center",
      justifyContent: "center"
    };
  }

  var hasLeft = parts[0] === "left" || parts[1] === "left";
  var hasRight = parts[0] === "right" || parts[1] === "right";
  var hasTop = parts[0] === "top" || parts[1] === "top";
  var hasBottom = parts[0] === "bottom" || parts[1] === "bottom";
  var horizontalAlignment = hasLeft ? "flex-start" : hasRight ? "flex-end" : "center";
  var verticalAlignment = hasTop ? "flex-start" : hasBottom ? "flex-end" : "center";
  return {
    alignItems: direction === "row" ? verticalAlignment : horizontalAlignment,
    justifyContent: direction === "row" ? horizontalAlignment : verticalAlignment
  };
}